export const TABLE = {
  MAX_TABLE_DATA: 3,
}
